/* eslint-disable no-mixed-operators */
import * as React from 'react';
import { IColumn, SelectionMode, ConstrainMode } from '@fluentui/react/lib/DetailsList';
import Constants from '../../../core/libraries/Constants';
import ListActionsMenu from '../../../core/common/ListActionsMenu';
import { connect } from 'react-redux';
import { RootState } from '../../../store/store';
import Helper from '../../../core/libraries/Helper';
import RbLabel, { LabelSize } from '../../../bosch-react/components/label/RbLabel';
import { getBookmarks, removeBookmark } from '../services';
import { IUserProfile } from '../../Auth/types';
import { confirmDialog, showDialog, showToastMessage } from '../../Dialog/actions';
import { IBookmarkDetail } from '../types';
import { DirectionalHint, IListProps, Link, ShimmeredDetailsList, TooltipHost } from '@fluentui/react';
import Template from '../../../core/libraries/Template';
import RbButton, { ButtonSize } from '../../../bosch-react/components/button/RbButton';
import Configuration from '../../../core/libraries/Configuration';
import DetailsListWrapper from '../../../core/components/DetailsListWrapper/DetailsListWrapper';
import { convertPeopleAndGroupObjectArrToStringArr } from '../../../utils/converter';

interface MyBookmarksProps {
    userProfile: IUserProfile | undefined,
    confirmDialog: typeof confirmDialog,
    showDialog: typeof showDialog,
    showToastMessage: typeof showToastMessage,
}
interface IState {
    bookmarks: IBookmarkDetail[] | any,
    filteredItems: IBookmarkDetail[] | null,
    isAdminMode: boolean,
}
class MyBookmarks extends React.Component<MyBookmarksProps, IState> {
    private timeoutId: NodeJS.Timeout | null = null;

    constructor(props: MyBookmarksProps) {
        super(props);
        this.state = {
            bookmarks: [],
            filteredItems: [],
            isAdminMode: false
        }
        this.openRemoveBookmarkDialog = this.openRemoveBookmarkDialog.bind(this);
        this.removeBookmark = this.removeBookmark.bind(this);
    }

    async componentDidMount() {
        Helper.runNewTask(() => {
            this.getBookmarks();
        });
    }

    async getBookmarks() {
        this.setState({
            filteredItems: null
        }, async () => {
            let bookmarks: IBookmarkDetail[] = []
            try {
                bookmarks = await getBookmarks(this.state.isAdminMode)
                this.setState({
                    bookmarks: !!bookmarks && bookmarks || [],
                    filteredItems: !!bookmarks && bookmarks || []
                })
            } catch (error) {
                console.log(error);
            }
        })
    }

    shimmeredDetailsListProps: IListProps = {
        renderedWindowsAhead: 0,
        renderedWindowsBehind: 0,
    };

    normalColumns: IColumn[] = [
        {
            key: 'documentTitle',
            name: 'Document Title',
            fieldName: 'ReportTitle',
            currentWidth: Helper.resizeColumnByScreenWidth(20),
            minWidth: Helper.resizeColumnByScreenWidth(20),
            isResizable: true,
            isRowHeader: true,
            data: 'string',
            isPadded: true,
            onRender: (item: IBookmarkDetail) => {
                return (
                    <Link href={Helper.generateAccessMediatorUrl(item.reportId)}>{item.title}</Link>
                );
            }
        },
        {
            key: 'authors',
            name: 'Authors',
            fieldName: 'Authors',
            currentWidth: Helper.resizeColumnByScreenWidth(20),
            minWidth: Helper.resizeColumnByScreenWidth(20),
            isResizable: true,
            isRowHeader: true,
            data: 'string',
            isPadded: true,
            isMultiline: true,
            onRender: (item: IBookmarkDetail) => {
                return Template.renderReadOnlyPeople(convertPeopleAndGroupObjectArrToStringArr(item.authors), item.authorDisplayName)
            }
        },
        {
            key: 'bookmarkDate',
            name: 'Bookmark Date',
            fieldName: 'Created',
            currentWidth: Helper.resizeColumnByScreenWidth(15),
            minWidth: Helper.resizeColumnByScreenWidth(15),
            isResizable: true,
            isRowHeader: true,
            data: 'string',
            isPadded: true,
            isMultiline: true,
            onRender: (item: IBookmarkDetail) => {
                return (<RbLabel size={LabelSize.Small} >{item.created}</RbLabel>);
            }
        },
        {
            key: 'keywords',
            name: 'Keywords',
            fieldName: 'Keywords',
            currentWidth: Helper.resizeColumnByScreenWidth(20),
            minWidth: Helper.resizeColumnByScreenWidth(20),
            isResizable: true,
            isRowHeader: true,
            data: 'string',
            isPadded: true,
            onRender: (item: IBookmarkDetail) => {
                return (
                    <TooltipHost
                        directionalHint={DirectionalHint.leftCenter}
                        content={item.keywords}>
                        {item.keywords}
                    </TooltipHost>
                );
            }
        },
    ]

    actionColumns: IColumn[] = [{
        key: 'unBookmark',
        name: '',
        fieldName: 'Actions',
        currentWidth: Helper.resizeColumnByScreenWidth(20),
        minWidth: Helper.resizeColumnByScreenWidth(20),
        isRowHeader: true,
        data: 'string',
        isPadded: true,
        onRender: (item: IBookmarkDetail) => {
            return (
                <RbButton label="Remove" size={ButtonSize.Small} onClick={() => {
                    this.openRemoveBookmarkDialog(item)
                }} />
            );
        }
    }]

    adminColumns: IColumn[] = [{
        key: 'createdBy',
        name: 'Created By',
        currentWidth: Helper.resizeColumnByScreenWidth(15),
        minWidth: Helper.resizeColumnByScreenWidth(15),
        isResizable: true,
        isRowHeader: true,
        data: 'string',
        isPadded: true,
        onRender: (item: IBookmarkDetail) => {
            return Template.renderReadOnlyPeople([item.createdBy]);
        }
    }]


    _onChangeText(text: string) {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout(() => {
            this.setState({
                filteredItems: text ? [...this.state.bookmarks ?? []].filter(i => i.title && i.title.toLowerCase().indexOf(text) > -1
                    || i.workflowId && i.workflowId.toLowerCase().indexOf(text) > -1) : [...this.state.bookmarks ?? []],
            });
        }, 500);
    }
    changeMode() {
        this.setState({
            isAdminMode: !this.state.isAdminMode
        }, () => {
            Helper.runNewTask(() => {
                this.getBookmarks();
            });
        })
    }

    render() {
        let modeColumns = this.state.isAdminMode && [...this.normalColumns, ...this.adminColumns, ...this.actionColumns] || [...this.normalColumns, ...this.actionColumns];
        let { filteredItems } = this.state
        let element = (
            <div className="ms-Grid">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm1" />
                    <div className="ms-Grid-col ms-sm10">
                        <div className="ms-Grid">
                            <div className="ms-Grid-row">
                                <RbLabel className="header-title" size={LabelSize.Large}>Bookmarks</RbLabel>
                            </div>
                            <ListActionsMenu
                                columns={modeColumns}
                                items={filteredItems || []}
                                searchText={(value: any) => { this._onChangeText(value) }}
                                showAdminResults={this.state.isAdminMode}
                                getAdminData={() => {
                                    this.changeMode();
                                }} />
                        </div>
                        <DetailsListWrapper>
                            <ShimmeredDetailsList
                                setKey="set"
                                compact={true}
                                items={filteredItems || []}
                                constrainMode={ConstrainMode.unconstrained}
                                columns={modeColumns}
                                selectionMode={SelectionMode.single}
                                enableShimmer={!filteredItems}
                                ariaLabelForShimmer="Content is being fetched"
                                ariaLabelForGrid="Bookmark details"
                                listProps={this.shimmeredDetailsListProps}
                                onRenderDetailsHeader={Configuration.onRenderStickyDetailsHeader}
                                onShouldVirtualize={() => { return true }}
                            />
                        </DetailsListWrapper>
                    </div>
                    <div className="ms-Grid-col ms-sm1" />
                </div>
            </div>
        );
        return element;
    }

    openRemoveBookmarkDialog(item: IBookmarkDetail) {
        this.props.confirmDialog(
            Constants.CONFIRMATION_MESSAGE.REMOVE_BOOKMARK.TITLE,
            Constants.CONFIRMATION_MESSAGE.REMOVE_BOOKMARK.CONTENT.replace("{0}", item.title), false,
            () => {
                this.removeBookmark(item);
            }
        );
    }

    removeBookmark(item: IBookmarkDetail) {
        this.props.showDialog(Constants.DIALOG_MESSAGE.REMOVE_BOOKMARK);
        removeBookmark(item.id, this.state.isAdminMode).then((result: any) => {
            if (result === true) {
                this.props.showToastMessage(
                    Constants.TOAST_MESSAGE_CODE.SUCCESS,
                    Constants.BOOKMARK_MESSAGE.REMOVE.SUCCESS.replace("{0}", item.title)
                );
                const refreshedBookmarks = this.state.bookmarks?.filter((bookmark: IBookmarkDetail) => bookmark.id !== item.id);
                this.setState({
                    bookmarks: refreshedBookmarks,
                    filteredItems: refreshedBookmarks
                })
                Helper.removeBookmarkSessionStorage(Number.parseInt(item.reportId))
            }
            else {
                this.props.showToastMessage(
                    Constants.TOAST_MESSAGE_CODE.ERROR,
                    Constants.BOOKMARK_MESSAGE.REMOVE.FAILED.replace("{0}", item.title)
                );
            }
            this.props.showDialog(false);
        }).catch(() => {
            this.props.showToastMessage(
                Constants.TOAST_MESSAGE_CODE.ERROR,
                Constants.BOOKMARK_MESSAGE.REMOVE.FAILED.replace("{0}", item.title)
            );
            this.props.showDialog(false);
        });
    }

}

const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile,
});

export default connect(mapStateToProps, { confirmDialog, showDialog, showToastMessage })(MyBookmarks);